<div class="w-full h-full flex justify-center">

    <div class="w-full">

        <div class="w-full flex flex-col gap-8">
            <div class="w-full flex flex-row md:justify-end items-center gap-5">
                <!-- Title & Subtitle -->
                <div class="w-full flex flex-col gap-[5px]" [ngClass]="{'hidden': !breakpoint.md.value}">
                    <div class="flex items-center gap-1">
                        <p class="text-[22px] font-semibold" i18n>
                            Modellen
                        </p>
                    </div>
                    <p class="text-[16px] text-app-global-text-secondary" i18n>Modellen in de hele applicatie
                    </p>
                </div>

                <div class="flex flex-col-reverse justify-end xs:flex-row w-full gap-3 md:gap-5">
                    <!-- Search -->
                    <mat-form-field class="w-full md:max-w-60 search">
                        <input matInput i18n-placeholder placeholder="Zoeken..." [formControl]="searchControl">
                    </mat-form-field>

                    <!-- New model -->
                    <button mat-flat-button color="primary" class="shrink-0" routerLink="/settings/models/new">
                        <span *ngIf="breakpoint.lg.value && !breakpoint.xl.value" i18n>
                            Nieuw
                        </span>
                        <span *ngIf="!(breakpoint.lg.value && !breakpoint.xl.value)" i18n>
                            Nieuw model
                        </span>
                    </button>
                </div>
            </div>


            <!-- Models table -->
            <app-table [settings]="modelsTableSettings" #table>
                <!-- Model -->
                <ng-container matColumnDef="model">
                    <th mat-header-cell *matHeaderCellDef i18n> Model naam </th>
                    <td mat-cell *matCellDef="let model">
                        <p>{{model.model}} </p>
                    </td>
                </ng-container>

                <!-- Provider -->
                <ng-container matColumnDef="provider">
                    <th mat-header-cell *matHeaderCellDef i18n> Provider
                    </th>
                    <td mat-cell *matCellDef="let model">
                        <p>{{model.provider}}</p>
                    </td>
                </ng-container>

                <!-- Type -->
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef i18n [ngClass]="{'hidden': !breakpoint.lg.value}"> Type
                    </th>
                    <td mat-cell *matCellDef="let model" [ngClass]="{'hidden': !breakpoint.lg.value}">
                        <p>{{ model.type_label }}</p>
                    </td>
                </ng-container>

                <!-- Usage -->
                <ng-container matColumnDef="usage">
                    <th mat-header-cell *matHeaderCellDef i18n [ngClass]="{'hidden': !breakpoint.lg.value}"> Gebruik
                    </th>
                    <td mat-cell *matCellDef="let model" [ngClass]="{'hidden': !breakpoint.lg.value}">
                        <p>{{ model.model_usage_count }}</p>
                    </td>
                </ng-container>

                <!-- Created at -->
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef [ngClass]="{'hidden': !breakpoint.lg.value}" i18n>
                        Aangemaakt op
                    </th>
                    <td mat-cell *matCellDef="let model" matTooltip="{{model.created_at | date: 'dd/MM/yyyy HH:mm'}}"
                        [ngClass]="{'hidden': !breakpoint.lg.value}">
                        <p>{{model.created_at | date: 'dd/MM/yyyy'}} </p>
                    </td>
                </ng-container>

                <!-- Actions -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef i18n></th>
                    <td mat-cell *matCellDef="let model">
                        <div class="flex items-center justify-end w-full">
                            <!-- Edit -->
                            <button mat-button i18n class="text-app-global-primary">
                                <mat-icon svgIcon="pencil"></mat-icon>
                                Bewerken
                            </button>
                        </div>
                    </td>
                </ng-container>
            </app-table>
        </div>
    </div>
</div>